











































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { Track } from '@/classes/track'
import { format, subDays, setMinutes, setHours, addHours, setSeconds, addDays, parseISO } from 'date-fns'
import { IColumnDef } from '@/interfaces/ag-grid'
import { toDateStringSafe } from '@/helpers/date'
import { LibraryMixin } from '@/mixins'
import { TrackFieldsLabels, TrackFields } from '@/constants'
import { USAGE_STAT_FEATURES } from '@/system/usage-stats'
const AgGridVue = () => import('@/modules/ag-grid')

const DATE_FORMAT = 'yyyy/MM/dd'

@Component({
  components: {
    AgGridVue,
    CopyTextModal: require('@/components/CopyTextModal').default,
    PlaylistSaveModal: require('@/components/PlaylistSaveModal').default
  }
})
export default class GenerateSetList extends Mixins(LibraryMixin) {
  loading: boolean = false

  gridApi: any
  columnApi: any

  date: Date = new Date()
  startTime: Date = new Date()
  endTime: Date = new Date()

  columnDefs: IColumnDef[] = [
    {
      headerName: TrackFieldsLabels[TrackFields.LastPlayed],
      field: TrackFields.LastPlayed,
      valueGetter: (params: any) => {
        const lastPlayed: string = (params.data as Track).lastPlayed

        if (lastPlayed) return format(parseISO(lastPlayed), `${DATE_FORMAT} H:mm`)
        else return '-'
      }
    },
    {
      headerName: TrackFieldsLabels[TrackFields.Title],
      field: TrackFields.Title
    },
    {
      headerName: TrackFieldsLabels[TrackFields.Artist],
      field: TrackFields.Artist,
      width: 150
    },
    {
      headerName: TrackFieldsLabels[TrackFields.Album],
      field: TrackFields.Album,
      width: 150
    }
  ]

  get suggestedPlaylistName(): string {
    return `Setlist ${toDateStringSafe(this.date)}`
  }

  onGridReady(params: any) {
    this.gridApi = params.api
    this.columnApi = params.columnApi

    this.gridApi.sizeColumnsToFit()
  }

  getRowNodeId(track: any) {
    return track._id
  }

  formatDate(date: Date): string {
    return `${format(date, 'EEEE')} ${date.toLocaleDateString()}`
  }

  openCopyModal() {
    (this.$refs.copyTextModal as any).openModal()
  }

  saveUsageStat() {
    window.addUsageStat(USAGE_STAT_FEATURES.GenerateSetlist, 'save')
  }

  created() {
    this.date = new Date()
    this.date = subDays(this.date, 1)
    this.date = setSeconds(this.date, 0)
    this.date = setMinutes(this.date, 0)

    this.startTime = this.date
    this.startTime = setHours(this.startTime, 20)

    this.endTime = this.startTime
    this.endTime = addHours(this.endTime, 8)
  }

  get tracks(): Track[] {
    if (!this.library) return []

    return this.library.tracks // tODO: test sorting
      .filter(x => x.lastPlayed && new Date(x.lastPlayed) >= this.startTime && new Date(x.lastPlayed) <= this.endTime) // TODO: if track starts at same minute as startTime, then its not shown but should be
      .sort((a, b) => a.lastPlayed.toString().localeCompare(b.lastPlayed.toString()))
  }

  @Watch('date')
  updateTimes(d: Date) {
    this.startTime = setMinutes(setHours(d, this.startTime.getHours()), this.startTime.getMinutes())
    this.endTime = addDays(setMinutes(setHours(d, this.endTime.getHours()), this.endTime.getMinutes()), 1)
  }
}
